import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import ScaleLoader from "react-spinners/ScaleLoader";
import { Button } from '@material-ui/core';
import BarChartIcon from '@mui/icons-material/BarChart';
const EventQuickAnalytics = (props) => {
  const { eventID, eventStatus } = props
  const analytics = useSelector(state => state.data.eventAnalytics[eventID])

  // not live statuses are available, publishing, published, and new
  const isEventLive = !["available", "publishing", "published", "new"].includes(eventStatus)

  return (
    <div className='quick-stats clearfix'>
      <div style={{ float: 'left' }}>
        {isEventLive && (
        <div className='quick-stats-row'>
          <span className='quick-stats-icon live'>
            <i className='fa fa-eye' aria-hidden='true' />
          </span>

          <span className='quick-stats-label'>Viewers watching:</span>

          <span className='quick-stats-value'>
            {analytics ? <strong>{analytics.ActivePlayers}</strong> : <span>loading  <ScaleLoader  height={5} width={3} radius={2} margin={2} color={"#333"} loading={true} speedMultiplier={0.5} /></span>}
          </span>
        </div>
        )}

        <div className='quick-stats-row'>
          <span className='quick-stats-icon vod'>
            <i className='fa fa-eye' aria-hidden='true' />
          </span>

          <span className='quick-stats-label'>Total plays:</span>

          <span className='quick-stats-value'>
            {analytics ? <strong>{analytics.verifiedPlayCount}</strong> :  <span>loading  <ScaleLoader  height={5} width={3} radius={2} margin={2} color={"#333"} loading={true} speedMultiplier={0.5} /></span>}

            {analytics && analytics.verifiedPlayCount ? (
              <span className='quick-stats-details'>
                {' | LIVE: '}
                <strong>{(analytics && analytics.LIVE) + ' '}</strong>
                VOD: <strong>{(analytics && analytics.VOD) + ' '}</strong><br />
                View Time:  <strong>{(analytics && analytics.timeWatched) + ' '}</strong>
              </span>
            ) :null}
             
          </span>
        </div> 
      </div>

      <div className='quick-stats-link' style={{ float: 'right' }}>
        {analytics && (analytics.VOD || analytics.LIVE) ? (
          <Link to={'/analytics?eventID=' + eventID}>
           <Button variant="outlined" size="small" startIcon={<BarChartIcon />}>
           View More
          </Button>
          </Link>
        ) : (
          <span>
           <Button disabled={true} variant="outlined" size="small" startIcon={<BarChartIcon />}>
            View More
          </Button>
          </span>
        )}
      </div>
    </div>
  )
}


export default EventQuickAnalytics
